import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/account-utilities/app/open/client.tsx");
